import { useNavigate } from 'react-router-dom';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import notFoundSvg from 'assets/not-found.svg';
import { ErrorPage } from 'components/error-page/error-page.component';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

export const PageNotFound = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  useDocumentTitle(formatMessage({ id: 'STR_PAGE_NOT_FOUND' }));

  return (
    <ErrorPage
      imageSrc={notFoundSvg}
      headingString={formatMessage({ id: 'STR_PAGE_NOT_FOUND' })}
      bodyString={formatMessage({ id: 'STR_SORRY_WE_CANT_FIND_PAGE' })}
      buttonText={formatMessage({ id: 'STR_GO_TO_HOMEPAGE' })}
      onButtonClick={() => navigate(APP_MANAGED_ROUTES.HOME)}
    />
  );
};
